import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=a0fa5eda&"
import script from "./VendorCard.vue?vue&type=script&lang=js&"
export * from "./VendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fa5eda')) {
      api.createRecord('a0fa5eda', component.options)
    } else {
      api.reload('a0fa5eda', component.options)
    }
    module.hot.accept("./VendorCard.vue?vue&type=template&id=a0fa5eda&", function () {
      api.rerender('a0fa5eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-resources/cards/VendorCard.vue"
export default component.exports